import ButtonCancel from "../../components/buttons-navigation/button-cancel";

export default function ApplicationHeader({ subtitle, title, navigation, children  }) {
    return (
        <div className="state-pages__header">
            <div className="state-pages-header__section">
                { navigation }
            </div>
            <div className="state-pages-header__section">
                { title }
            </div>
            <div className="state-pages-header__section">
                { subtitle }
            </div>

        </div>
    )
}
